import * as React from 'react';
/**
 * A React context that provides access to one or more configured GraphQL clients.
 *
 * @type {React.Context<IGraphQLContext>}
 */
var GraphQLContext = React.createContext(null);
export default GraphQLContext;
